export default () => {
  const currentShop = useCurrentShop()
  const key = `default-fim-filters-${currentShop.value.shopId}')`
  return useRpc('getDefaultFimListingFilters', key, undefined, {
    immediate: true,
  })
}
